(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zw-banner-statisch"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('zw-benefit-banner')) {
    customElements.define('zw-benefit-banner', class extends HTMLElement {
      #alle = [];
      #mobil = [];
      #knopf;
      #desktop;
      #reduziert;
      #ereignisse;
      #timer = 0;
      #ueberblendung = 0;
      #aktuell = 0;
      #pausiert = false;
      #fokus = false;
      #zeiger = false;

      connectedCallback() {
        if (this.#ereignisse || !window.matchMedia) return;
        this.#alle = Array.from(this.querySelectorAll('[data-zw-vorteil]'));
        this.#mobil = ['4', '3', '5'].map(nummer => this.#alle.find(punkt => punkt.dataset.zwVorteil === nummer)).filter(Boolean);
        this.#knopf = this.querySelector('[data-zw-banner-pause]');
        if (!this.#mobil.length || !this.#knopf) return;
        this.#desktop = window.matchMedia('(min-width: 750px)');
        this.#reduziert = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.#ereignisse = new AbortController();
        const optionen = { signal: this.#ereignisse.signal };
        this.#desktop.addEventListener('change', () => this.#abgleichen(), optionen);
        this.#reduziert.addEventListener('change', () => this.#abgleichen(), optionen);
        document.addEventListener('visibilitychange', () => document.hidden ? this.#anhalten() : this.#starten(), optionen);
        this.#knopf.addEventListener('click', () => {
          this.#pausiert = !this.#pausiert;
          this.#knopfAktualisieren();
          this.#pausiert ? this.#anhalten() : this.#starten();
        }, optionen);
        this.addEventListener('focusin', () => {
          this.#fokus = this.#alle.some(punkt => punkt.contains(document.activeElement));
          if (this.#fokus) this.#anhalten();
        }, optionen);
        this.addEventListener('focusout', () => queueMicrotask(() => {
          if (!this.#ereignisse) return;
          this.#fokus = this.#alle.some(punkt => punkt.contains(document.activeElement));
          if (!this.#fokus) this.#starten();
        }), optionen);
        this.addEventListener('pointerenter', ereignis => {
          if (ereignis.pointerType !== 'mouse') return;
          this.#zeiger = true;
          this.#anhalten();
        }, optionen);
        this.addEventListener('pointerleave', () => {
          this.#zeiger = false;
          this.#starten();
        }, optionen);
        this.#abgleichen();
        this.setAttribute('data-enhanced', '');
      }

      disconnectedCallback() {
        this.#anhalten();
        this.#ereignisse?.abort();
        this.#ereignisse = null;
        this.#fokus = false;
        this.#zeiger = false;
      }

      #abgleichen() {
        this.#anhalten();
        if (this.#desktop.matches) {
          for (const punkt of this.#alle) {
            punkt.removeAttribute('data-aktiv');
            punkt.removeAttribute('aria-hidden');
            punkt.inert = false;
          }
          this.#knopf.hidden = true;
          return;
        }
        this.#anzeigen(0, false);
        this.#knopf.hidden = this.#reduziert.matches || this.#mobil.length < 2;
        this.#knopfAktualisieren();
        this.#starten();
      }

      #knopfAktualisieren() {
        this.#knopf.setAttribute('aria-label', this.#pausiert ? 'Hinweiswechsel fortsetzen' : 'Hinweiswechsel pausieren');
        this.#knopf.setAttribute('aria-pressed', String(this.#pausiert));
        this.#knopf.querySelector('[data-zw-pause-symbol]').toggleAttribute('hidden', this.#pausiert);
        this.#knopf.querySelector('[data-zw-weiter-symbol]').toggleAttribute('hidden', !this.#pausiert);
      }

      #anzeigen(index, sanft) {
        clearTimeout(this.#ueberblendung);
        const vorher = this.#mobil[this.#aktuell];
        const jetzt = this.#mobil[index];
        for (const punkt of this.#alle) {
          punkt.removeAttribute('data-ausblenden');
          punkt.toggleAttribute('data-aktiv', punkt === jetzt);
          punkt.setAttribute('aria-hidden', String(punkt !== jetzt));
          punkt.inert = punkt !== jetzt;
        }
        this.#aktuell = index;
        if (sanft && vorher && vorher !== jetzt && !this.#reduziert.matches) {
          vorher.setAttribute('data-ausblenden', '');
          this.#ueberblendung = setTimeout(() => {
            vorher.removeAttribute('data-ausblenden');
            this.#ueberblendung = 0;
          }, 340);
        }
      }

      #darfLaufen() {
        return this.isConnected && this.#ereignisse && !this.#desktop.matches && !this.#reduziert.matches && !document.hidden && !this.#pausiert && !this.#fokus && !this.#zeiger && this.#mobil.length > 1;
      }

      #starten() {
        clearTimeout(this.#timer);
        this.#timer = 0;
        if (!this.#darfLaufen()) return;
        this.#timer = setTimeout(() => {
          this.#timer = 0;
          if (!this.#darfLaufen()) return;
          this.#anzeigen((this.#aktuell + 1) % this.#mobil.length, true);
          this.#starten();
        }, 6000);
      }

      #anhalten() {
        clearTimeout(this.#timer);
        clearTimeout(this.#ueberblendung);
        this.#timer = 0;
        this.#ueberblendung = 0;
        for (const punkt of this.#alle) punkt.removeAttribute('data-ausblenden');
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
